<template>
  <div class="px-5 py-5">
    <notifications position="top center" ></notifications>

    <div class="flex flex-col center-content mb-7">
      <h2 class="font-bold text-center mb-5">Edit Representatives</h2>
    </div>

    <div class="space-y-5">
      <div>
        <label for="name" class="block text-sm font-medium text-gray-700">
          Name
        </label>
        <div class="mt-1">
          <input type="text" v-model="form.name" id="name" class="w-1/2 block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="title" class="block text-sm font-medium text-gray-700">
          Title
        </label>
        <div class="mt-1">
          <input type="text" v-model="form.title"  id="title" class="w-1/2 block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="email" class="block text-sm font-medium text-gray-700">
          Email
        </label>
        <div class="mt-1">
          <input type="text"  v-model="form.email" id="email" class="w-1/2 block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="phone" class="block text-sm font-medium text-gray-700">
          Phone
        </label>
        <div class="mt-1">
          <input type="text"  v-model="form.phone" id="phone" class="w-1/2 block sm:text-sm">
        </div>
      </div>

      <div>
        <label for="calendly_link" class="block text-sm font-medium text-gray-700">
          Calendy Link
        </label>
        <div class="mt-1">
          <input type="text" v-model="form.calendly_link" id="calendly_link" class="w-1/2 block sm:text-sm">
        </div>
      </div>

      <div>
        <div class="w-1/2 block sm:text-sm">
          <Multiselect
              v-model="form.selectedStates"
              :options="states"
              mode="tags"
          />

        </div>
      </div>

      <div class="flex space-x-3">
        <button @click="createOrUpdate"  type="button" class="inline text-center text-sm uppercase px-6 py-3 border border-transparent font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200"><i class="fas fa-check mr-2"></i> Save</button>
      </div>
    </div>
  </div>

</template>
<style src="@vueform/multiselect/themes/default.css"></style>

<script>
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    representativeId: null,
    representative: null,
    states: null,
    existingStates: null,
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        selectedStates: [],
        calendly_link: null,
        id: this.representativeId,
      }
    }
  },
  created() {
    if (this.representativeId){
      this.form = this.representative
      this.form.selectedStates = this.existingStates
    }
  },
  methods: {
    createOrUpdate() {
      if (!this.form.name){
        this.$notify({
          text: 'Name is required',
          type: 'error',
        })
        return
      }
      if (!this.form.email){
        this.$notify({
          text: 'Email is required',
          type: 'error',
        })
        return
      }
      if (!this.form.title){
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      if (!this.form.phone){
        this.$notify({
          text: 'Phone is required',
          type: 'error',
        })
        return
      }
      if (this.form.selectedStates.length === 0){
        this.$notify({
          text: 'State is required',
          type: 'error',
        })
        return
      }
      axios.post('/admin/representatives/create', this.form)
          .then(response => {
            // console.log(response.data)
            this.$notify({
              text: 'Representative event successfully ' + this.action(),
              type: 'success',
            })

            window.location.href = '/admin/representatives'
          })
    },
    action() {
      return this.representativeId ? 'updated' : 'created'
    },
  }
}
</script>
